import React, { useState } from "react";
import MediaObjectFormModal from "./MediaObjectFormModal";
import DocumentClassLabelAiProvider from "../../../provider/DocumentClassLabelAiProvider";
import ActionIdentifierProvider from "../../../provider/ActionIdentifierProvider";
import LegalbirdDropzone from "./LegalbirdDropzone";

import { ProductUnion } from "../../../types/ProductUnion";

type UploadFileProps = {
  open: boolean;
  closeDialog: Function;
  product: ProductUnion;
};

const UploadFile = ({ open, closeDialog, product }: UploadFileProps) => {
  const [files, setFiles] = useState<Array<File>>([]);

  const resetDialog = () => {
    setFiles([]);
    closeDialog();
  };

  return (
    <DocumentClassLabelAiProvider>
      <ActionIdentifierProvider>
        <MediaObjectFormModal
          product={product}
          closeDialog={resetDialog}
          open={open}
          fileData={{ file: files[0] }}
          submitDisabled={!files[0]}
        >
          <LegalbirdDropzone files={files} setFiles={setFiles} />
        </MediaObjectFormModal>
      </ActionIdentifierProvider>
    </DocumentClassLabelAiProvider>
  );
};

export default UploadFile;
